export default {
  name: null,
  role: null,
  groups: [],
};
